import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import api from "../lib/api";

export default function TopTicker() {
  const [symbols, setSymbols] = useState([]);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/ticker");
        if (active) setSymbols(data);
      } catch (error) {
        // Ticker is non-blocking — log but don't disrupt the page.
        console.error("Failed to load market ticker:", error);
      }
    };
    load();
    const t = setInterval(load, 15000);
    return () => { active = false; clearInterval(t); };
  }, []);

  return (
    <div className="ticker-bar text-white" data-testid="top-ticker">
      <Marquee speed={45} gradient={false} pauseOnHover>
        <div className="flex items-center gap-8 py-2 px-6 mono text-[11.5px]">
          <span className="text-[#f43f5e] font-bold">● LIVE MARKETS</span>
          {symbols.map((s) => (
            <span key={s.symbol} className="flex items-center gap-2" data-testid={`ticker-${s.symbol}`}>
              <span className="text-white/55">{s.name}</span>
              <span className="font-semibold">{s.price.toLocaleString()}</span>
              <span className={s.change >= 0 ? "ticker-up" : "ticker-down"}>
                {s.change >= 0 ? "▲" : "▼"} {Math.abs(s.change_pct)}%
              </span>
              <span className="text-white/25">|</span>
            </span>
          ))}
          <span className="text-[#fde4b6] font-bold">★ Available · Anything in the way — we haul it off · 24/7 dispatch</span>
        </div>
      </Marquee>
    </div>
  );
}
